import { useState } from "react";
import { Link } from "react-router-dom";
import { figures } from "@/mocks/figures";

const statusFilters = ["全部", "持续追踪", "待核验"];

export default function Renwu() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? figures : figures.filter((f) => f.status === active);

  return (
    <div className="bg-background-50">
      {/* page head */}
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <i className="ri-focus-3-line" /> 主角档案库
          </p>
          <h1 className="font-heading mt-3 max-w-2xl text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            反差人物的主角与当事人追踪档案
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这里收录本站正在持续梳理的「主角是谁」相关线索。每份档案都包含冲突点、涉及领域与当前状态，所有描述均基于公开信息整理，不代表最终定论。
          </p>
        </div>
      </section>

      {/* filter */}
      <div className="mx-auto max-w-7xl px-4 py-6 md:px-6">
        <div className="flex flex-wrap items-center gap-2">
          {statusFilters.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => setActive(s)}
              className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                active === s
                  ? "bg-primary-600 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {s}
            </button>
          ))}
          <span className="ml-auto text-sm text-foreground-500">共 {list.length} 份档案</span>
        </div>
      </div>

      {/* grid */}
      <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6">
        <div className="grid gap-4 md:grid-cols-2">
          {list.map((f) => (
            <article
              key={f.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  <i className="ri-bubble-chart-line" /> {f.category}
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800">
                  <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-600" />
                  {f.status}
                </span>
              </div>

              <div className="mt-4 flex items-start justify-between gap-3">
                <div>
                  <span className="text-xs text-foreground-400">{f.code}</span>
                  <h2 className="font-heading mt-1 text-xl font-bold text-foreground-950">{f.nick}</h2>
                  <p className="mt-1 text-xs text-foreground-500">
                    {f.area} · 更新于 {f.updated}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-fire-line" /> {f.hot}
                </span>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{f.summary}</p>

              <div className="mt-4 border-l-2 border-primary-400 bg-background-50 px-4 py-2.5 text-sm text-primary-800">
                {f.keypoint}
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                {f.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-500">证据仍处于梳理阶段</span>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-800"
                >
                  核验标准 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="py-16 text-center text-foreground-500">该状态下暂无档案。</p>
        )}
      </section>
    </div>
  );
}